import apiClient from "./index";

export const findAll = () => {
  return apiClient.get(`/admin/menuDgstfn/findAll.json`);
};

export const findAllByMenuId = (menuDgstfn) => {
  return apiClient.post(`/admin/menuDgstfn/findAllByMenuId.json`, menuDgstfn);
};

export const findByMenuId = (menuDgstfn) => {
  return apiClient.post(`/sys/menu/dgstfn/findByMenuId.json`, menuDgstfn);
};

export const save = (menuDgstfn) => {
  return apiClient.post(`/sys/menu/dgstfn/saveProc.json`, menuDgstfn);
};
